import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=a09168ea&scoped=true"
import script from "./PageMenu.vue?vue&type=script&lang=js"
export * from "./PageMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09168ea",
  null
  
)

export default component.exports